import * as THREE from "three";
import { Person, spawnPeople } from "./people";
import {
  Dolphin,
  DuckFlock,
  Frigate,
  Heron,
  Seagull,
  Seal,
  Tropicbird,
  spawnWildlife,
} from "./wildlife";

export class Habitat {
  readonly group = new THREE.Group();
  private people: Person[] = [];
  private seagulls: Seagull[] = [];
  private tropicbirds: Tropicbird[] = [];
  private frigates: Frigate[] = [];
  private flocks: DuckFlock[] = [];
  private herons: Heron[] = [];
  private dolphins: Dolphin[] = [];
  private seals: Seal[] = [];

  constructor() {
    this.group.name = "habitat";
    this.people = spawnPeople();
    const wild = spawnWildlife();
    this.seagulls = wild.seagulls;
    this.tropicbirds = wild.tropicbirds;
    this.frigates = wild.frigates;
    this.flocks = wild.flocks;
    this.herons = wild.herons;
    this.dolphins = wild.dolphins;
    this.seals = wild.seals;

    for (const p of this.people) this.group.add(p.group);
    const critters = [...this.seagulls, ...this.tropicbirds, ...this.frigates, ...this.herons, ...this.dolphins, ...this.seals];
    for (const c of critters) this.group.add(c.group);
    for (const f of this.flocks) this.group.add(f.group);
  }

  update(t: number, dt: number): void {
    for (const p of this.people) p.update(t, dt);
    for (const s of this.seagulls) s.update(t, dt);
    for (const b of this.tropicbirds) b.update(t);
    for (const b of this.frigates) b.update(t);
    for (const f of this.flocks) f.update(t, dt, this.flocks);
    for (const h of this.herons) h.update(t);
    for (const d of this.dolphins) d.update(t);
    for (const s of this.seals) s.update(t);
  }
}
